var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKalkukasidandampak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 314,
    viewBox: "0 0 284 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 314,
    rx: 6,
    fill: "#FFD9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 236,
    height: 77.027,
    rx: 6,
    fill: "#F9747F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 111.297,
    width: 236,
    height: 7.7027,
    rx: 3.85135,
    fill: "#F9747F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 143,
    width: 236,
    height: 77.027,
    rx: 6,
    fill: "#F9747F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 230.297,
    width: 236,
    height: 7.7027,
    rx: 3.85135,
    fill: "#F9747F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 270,
    width: 236,
    height: 20,
    rx: 6,
    fill: "#F9747F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalkukasidandampak);
export default __webpack_public_path__ + "static/media/kalkukasidandampak.98cf2d3f0b522e138f1f4ef7ee3798e0.svg";
export { ForwardRef as ReactComponent };